<div class="page">
    <div class="two-column-layout">
        <div class="left-column">
            <app-device-live-view [isBusy]="isBusy"
                                  [entityId]="unitId"
                                  [installationId]="installationId"
                                  [shadowUpdates]="shadowUpdates"
                                  [entityKind]="CallEntityKind.Unit"
                                  [placeholderUrl]="unit?.image_url ?? 'assets/images/background.jpeg'">
            </app-device-live-view>
        </div>
        <div class="right-column">
            <app-widget-card
                    icon="assets/icons/ic_device.svg"
                    [title]="'General.Devices' | i18next"
                    [showAreaPlaceholder]="isBusy"
                    minHeight="500px"
            >
                <div style="height: 565px; overflow-y: auto">
                    <dx-data-grid [dataSource]="unit?.devices || []" [hoverStateEnabled]="false">
                        <dxi-column dataField="name" [caption]="'General.Name' | i18next"></dxi-column>
                        <dxi-column
                                dataField="product_line"
                                [caption]="'General.DeviceLine' | i18next"
                                alignment="left"
                                cellTemplate="productLineTemplate"
                        >
                            <div *dxTemplate="let data of 'productLineTemplate'">
                                {{ data.value | productLineName }}
                            </div>
                        </dxi-column>
                        <dxi-column
                                name="output"
                                dataField="available_outputs"
                                [caption]="'General.Outputs' | i18next"
                                alignment="left"
                                cellTemplate="outputsTemplate"
                        >
                            <div *dxTemplate="let data of 'outputsTemplate'">
                                <ng-container *ngIf="data?.value.length > 0">
                                    <div *ngFor="let output of data.value">
                                        {{ output.name }}
                                    </div>
                                </ng-container>
                            </div>
                        </dxi-column>
                        <dxi-column
                                [caption]="'General.Actions' | i18next"
                                alignment="left"
                                cellTemplate="actions"
                                width="auto"
                        >
                            <div *dxTemplate="let data of 'actions'">
                                <div style="display: flex; align-items: center; gap: 10px;">
                                    <dx-button
                                            *ngIf="shouldShowLiveViewButton(data.data)"
                                            class="live-view-button"
                                            [text]="'Dashboard.DeviceLiveView' | i18next"
                                            type="default"
                                            (onClick)="liveViewButtonClick(data.data)"
                                            [disabled]="!isDeviceReady(data.data)"
                                    ></dx-button>
                                    <dx-button
                                            *ngIf="shouldShowBusyButton(data.data)"
                                            class="busy-button"
                                            [text]="'Dashboard.BusyDevice' | i18next"
                                            type="default"
                                            [disabled]="true"
                                    ></dx-button>
                                    <dx-load-indicator
                                            *ngIf="deviceNotificationToggleStates.get(data.data?.id)"
                                            class="notification-icon"
                                            [visible]="true">
                                    </dx-load-indicator>
                                    <svg-icon
                                            *ngIf="!deviceNotificationToggleStates.get(data.data?.id)"
                                            class="notification-icon"
                                            [src]="data.data?.notification_preferences?.enabled === false
                                        ? 'assets/icons/ic_notifications_off.svg'
                                        : 'assets/icons/ic_notifications_on.svg'"
                                            (click)="toggleDeviceNotification(data.data)">
                                    </svg-icon>
                                </div>
                            </div>
                        </dxi-column>
                    </dx-data-grid>
                </div>
            </app-widget-card>
        </div>
    </div>

    <div class="two-column-layout">
        <div class="left-column">
            <app-call-events-card [installationId]="installationId" [entityId]="unitId"
                [devices]="unit?.devices" [eventsProvider]="unitEventsProvider">
            </app-call-events-card>
        </div>
        <div class="right-column">
        </div>
    </div>
</div>

